import { jsx as C } from "react/jsx-runtime";
const l = () => /* @__PURE__ */ C(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.40726 3.52381L1.26244 18.0005C0.509434 19.3389 1.46666 21 2.99094 21H21.0091C22.5333 21 23.4906 19.3389 22.7376 18.0005L14.5927 3.52381C13.4497 1.49206 10.5503 1.49206 9.40726 3.52381ZM11.006 12.9191C11.006 13.5012 11.451 13.9731 12 13.9731C12.549 13.9731 12.994 13.5012 12.994 12.9191V9.00406C12.994 8.42193 12.549 7.95003 12 7.95003C11.451 7.95003 11.006 8.42193 11.006 9.00406V12.9191ZM12.994 15.9808C12.994 16.5352 12.5519 16.9846 12.0066 16.9846H11.9934C11.4481 16.9846 11.006 16.5352 11.006 15.9808C11.006 15.4264 11.4481 14.9769 11.9934 14.9769H12.0066C12.5519 14.9769 12.994 15.4264 12.994 15.9808Z",
    fill: "currentColor"
  }
);
export {
  l as default
};
